import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-transferManag",
  "use": "icon-transferManag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-transferManag\"><defs><style type=\"text/css\"></style></defs><path d=\"M919.2 355.2L531.2 77.6c-11.2-8-26.4-8-36.8 0L104 355.2c-12.8 8.8-6.4 28.8 9.6 28.8H192v496c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V384h78.4c15.2 0 21.6-20 8.8-28.8zM280.8 512h51.2c26.4-74.4 97.6-127.2 180.8-127.2 56.8 0 107.2 24.8 142.4 64l-57.6 32.8c-22.4-20-52.8-32.8-84.8-32.8-47.2 0-88 25.6-110.4 63.2h51.2L367.2 597.6 280.8 512z m412 128C665.6 714.4 595.2 767.2 512 767.2c-56 0-106.4-24-141.6-63.2l57.6-32.8c22.4 20 52 32 84 32 47.2 0 88-25.6 110.4-63.2h-51.2l86.4-85.6L743.2 640h-50.4z\" p-id=\"1790\" fill=\"#ebeef5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/transferManag.svg
// module id = +nhW
// module chunks = 168